<div class="container">
  <h1 class="header">
    <div class="title">
      <mat-icon class="warning" fontIcon="warning_amber"></mat-icon>Amazon
      Connect 連携を解除しますか？
    </div>
    <button
      type="button"
      mat-icon-button
      class="close-button"
      aria-label="閉じる"
      (click)="this.close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div class="main">
    <div class="success-message">
      <p>
        発行済みの API キーはすべて失効し、元に戻せません。顧客側（Amazon
        Connect 側の
        Lambda）の設定を再発行したキーで更新するまで入稿は停止します。SkillMap
        と送信元 CIDR の設定は残ります。
      </p>
    </div>
  </div>
  <div class="footer">
    <button rectangle variant="secondary" (click)="this.cancel()">
      キャンセル
    </button>
    <button rectangle variant="primary" (click)="this.disconnect()">
      連携を解除
    </button>
  </div>
</div>
